import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TEMPLATE_IMAGE_URL } from 'knowledge-content-ui/constants/ChooseTemplateConstants';
import UsageTracker from '../../utils/UsageTracker';
import { SCREENS } from '../../constants/TrackingConstants';
import ChangeTemplate from '../../components/templateEditor/chooseTemplate/ChangeTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.templateEditor.fields.themeType';
const TEMPLATE_IMAGE_HEIGHT = 273;
const TEMPLATE_IMAGE_WIDTH = 368;
class TemplateTypeField extends Component {
  constructor(props) {
    super(props);
    this.handleChangeTemplateClick = () => {
      UsageTracker.track('templateEditorInteraction', {
        screen: SCREENS.TEMPLATE_EDITOR,
        action: 'style-change-template-click'
      });
      this.setState({
        showChangeTemplateContainer: true
      });
    };
    this.handleChangeTemplateClose = () => {
      this.setState({
        showChangeTemplateContainer: false
      });
    };
    this.state = {
      showChangeTemplateContainer: false
    };
  }
  render() {
    const {
      readOnly,
      value
    } = this.props;
    const {
      showChangeTemplateContainer
    } = this.state;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Image, {
        height: TEMPLATE_IMAGE_HEIGHT
        // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
        ,
        src: TEMPLATE_IMAGE_URL[value],
        width: TEMPLATE_IMAGE_WIDTH
      }), /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        marginBlockStart: "500",
        children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
          message: `${I18N_PREFIX}.selectedTemplate`,
          options: {
            templateText: /*#__PURE__*/_jsx("strong", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `knowledgeContentUI.chooseTemplate.templates.${value}.title`
              })
            })
          }
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "change-template-button",
          disabled: readOnly,
          onClick: this.handleChangeTemplateClick,
          size: "small",
          use: "tertiary-light",
          marginBlockStart: "300",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `${I18N_PREFIX}.changeTemplateButtonLabel`
          })
        })]
      }), showChangeTemplateContainer && /*#__PURE__*/_jsx(ChangeTemplate
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      , {
        currentTemplate: value,
        onClose: this.handleChangeTemplateClose
      })]
    });
  }
}
TemplateTypeField.propTypes = {
  readOnly: PropTypes.bool,
  value: PropTypes.string
};
export default TemplateTypeField;